export default Math.random;